module.exports = __webpack_public_path__ + "fonts/d0dbfc93-f3b1-486e-b8b5-66d984f65eff.b55f067.ttf";